<template>
    <div class="list-group-item d-flex"
         v-bind:class="{ dragging }">
        <div class="flex-grow-1 d-flex align-items-center">
            <color-dot class="mr-2"
                       v-bind:color="category.color">
            </color-dot>
            {{ category.name | capitalize }}
        </div>
        <div>
            <button class="btn btn-outline-dark border-0"
                    v-on:click="isEditCategoryModalOpen = true">
                <font-awesome-icon icon="edit"></font-awesome-icon>
            </button>
            <button class="btn btn-outline-danger border-0"
                    v-bind:class="{ 'btn-loading': isLoading }"
                    v-on:click="deleteCategory">
                <font-awesome-icon icon="trash-alt"></font-awesome-icon>
            </button>
        </div>

        <modal-category is-editing
                        type="vending"
                        v-bind:category="category"
                        v-model="isEditCategoryModalOpen">
        </modal-category>
    </div>
</template>

<script>
    import ModalCategory from "../ModalCategory";
    import ColorDot from "../../ColorDot";

    export default {
        name: "CategoryItem",
        components: {
            ColorDot,
            ModalCategory,
        },
        props: {
            "category": {
                type: Object,
                required: true,
            },

            "dragging": {
                type: Boolean,
                default: false,
            },
        },
        data () {
            return {
                isLoading: false,
                isEditCategoryModalOpen: false,
            };
        },
        computed: {

        },
        methods: {
            async deleteCategory () {
                this.isLoading = true;
                try {
                    await this.$store
                        .dispatch(
                            "data/deleteCategory",
                            this.category._id
                        );
                } catch (e) {
                    console.error(e);
                    this.isLoading = false
                }
                this.isLoading = false;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .list-group-item {
        &.dragging {
            animation-name: shake;
            animation-duration: 1250ms;
            animation-iteration-count: infinite;
            cursor: grab;
        }

        &:not(.dragging) {
            &:hover,
            &:focus {
                transform: scale(1.01);
            }
        }

        @keyframes shake {
            from,
            to {
                transform: translate3d(0, 0, 0);
            }

            10%,
            30%,
            50%,
            70%,
            90% {
                transform: translate3d(-2.5px, 0, 0);
            }

            20%,
            40%,
            60%,
            80% {
                transform: translate3d(2.5px, 0, 0);
            }
        }
    }
</style>
